import React, {useState, useEffect} from 'react';
import PlacesAutocomplete, {geocodeByAddress, geocodeByPlaceId} from 'react-places-autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default function GoogleMaps({handleAddress, address1}) {

    const [address, setAddress] = useState(null);

    useEffect(() => {
        setAddress(address1);
    }, [address1])

    const handleSelect = async (address, placeId) => {
        const [place] = await geocodeByPlaceId(placeId);
        handleAddress(place);
        setAddress(null)
    };

    const handleChage = address => {
        setAddress(address);
    }

  return (
    <div className="inputLine">
      <PlacesAutocomplete
        value={address}
        onChange={handleChage}
        onSelect={handleSelect}
        searchOptions={{region: 'uk'}}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
              <div className="inputFielders">
                <div className="fieldLine">
                    <Typography variant="body2" color="primary">Street Address</Typography>
                    <TextField
                        variant='standard'
                        // label="Address Line 1"
                        fullWidth
                        required
                        {...getInputProps({ placeholder: "", className: "inputField", })}
                      >
                    </TextField>
                </div>
                <div>
                  {loading ?
                    <div>
                      <LinearProgress color="primary"/>
                    </div> :
                    null}
                    <div className='suggestionDrop'>
                      {suggestions.map(suggestion => {
                        const style = {
                          backgroundColor: suggestion.active ? "#70247247" : "#ede8ed",
                          cursor: suggestion.active ? "pointer" : "default"
                        };
                        return (
                          <Typography
                            color="primary"
                            align="center"
                            {...getSuggestionItemProps(suggestion, { style })}
                            >
                            {suggestion.description}
                          </Typography>
                        );
                      })}
                    </div>
                  </div>
                </div>
            )}
      </PlacesAutocomplete>
    </div>
  );
}
